<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<div class="ewd">
  <div class="ewd__card">
    <header class="ewd__head">
      <div class="ewd__head-text">
        <h1 class="ewd__title">Employee Withdrawal</h1>
      </div>
    </header>

    <section class="ewd__sec" aria-labelledby="ewd-search-title">
      <h2 id="ewd-search-title" class="ewd__sec-title">Employee Search</h2>
      <div class="ewd__fld ewd__fld--search">
        <input
          id="ewd-employee-search"
          type="text"
          class="ewd__inp"
          matInput
          placeholder="Enter name, payroll or mobile"
          [formControl]="employeeSearch"
          [matAutocomplete]="employeeAuto"
        />
        <mat-autocomplete
          #employeeAuto="matAutocomplete"
          autoActiveFirstOption
          [displayWith]="displayEmployeeLabel"
          (optionSelected)="onEmployeeSelected($event)"
        >
          <mat-option
            *ngFor="let item of employeeOptions | async; trackBy: trackByPayrollId"
            [value]="item"
          >
            <span class="ewd__option">
              <span class="ewd__option-id">{{ getOptionPayrollId(item) }}</span>
              <span class="ewd__option-sep" *ngIf="getOptionPayrollId(item) && getOptionName(item)"> - </span>
              <span class="ewd__option-name">{{ getOptionName(item) }}</span>
            </span>
          </mat-option>
        </mat-autocomplete>
      </div>
    </section>

    <section class="ewd__sec" *ngIf="hasSelectedEmployee" aria-labelledby="ewd-details-title">
      <h2 id="ewd-details-title" class="ewd__sec-title">Employee Details</h2>
      <div class="ewd__grid" [formGroup]="employeeDetailsForm">
        <div class="ewd__fld" *ngFor="let field of detailFields">
          <label class="ewd__lbl" [attr.for]="field.id">{{ field.label }}</label>
          <input [id]="field.id" type="text" class="ewd__inp" [formControlName]="field.key" readonly />
        </div>
        <div class="ewd__fld ewd__fld--full">
          <label class="ewd__lbl" for="ewd-remarks">Remarks</label>
          <textarea
            id="ewd-remarks"
            class="ewd__ta"
            rows="4"
            placeholder="Enter remarks (min 10, max 250 characters)"
            [attr.maxlength]="maxRemarksLength"
            [formControl]="remarks"
          ></textarea>
          <div class="ewd__hint">
            <span *ngIf="remarksLength < 10">Minimum 10 characters required</span>
            <span class="ewd__hint-count">{{ remarksLength }}/{{ maxRemarksLength }}</span>
          </div>
        </div>
      </div>
    </section>

    <footer class="ewd__actions" *ngIf="canClear">
      <button
        type="button"
        class="ewd__btn ewd__btn--clear"
        [disabled]="isWithdrawing"
        (click)="onClear()"
      >
        Clear
      </button>
      <button
        *ngIf="hasSelectedEmployee"
        type="button"
        class="ewd__btn ewd__btn--primary"
        [disabled]="isWithdrawing || !canWithdraw"
        (click)="onWithdraw()"
      >
        Withdraw
      </button>
    </footer>
  </div>
</div>

